import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import FormError from 'components/common/FormError';
import Progress from 'components/common/Progress';
import IconCheck from 'components/icons/IconCheck';

import { submit, isSubmitting } from 'redux-form';

import Button from 'components/common/Button';
import pxToRem from 'styles/pxToRem';

const styles = theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    minHeight: 376,
    paddingBottom: 58,
    flexDirection: 'column',
    justifyContent: 'center',
    [theme.breakpoints.up('sm')]: {
      width: 556,
    },
  },
  footer: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    left: 0,
    padding: '8px 16px',
    borderTop: `1px solid ${theme.palette.primary.A100}`,
    [theme.breakpoints.up('sm')]: {
      padding: '8px 63px',
    },
    '& $grid': {
      justifyContent: 'space-between',
    },
  },
  grid: {

  },
  typography: {
    textTransform: 'uppercase',
    textAlign: 'center',
    paddingBottom: 14,
    margin: `${pxToRem(24)} ${pxToRem(113)}`,
    borderBottom: `1px solid ${theme.palette.primary.A100}`,
  },
  typographyText: {
    fontSize: pxToRem(13),
    margin: `0 ${pxToRem(113)} ${pxToRem(16)}`,
  },
  formError: {
    margin: '0 63px',
  },
  iconCheck: {
    width: 18,
    height: 18,
    color: theme.palette.active[500],
    marginRight: 4,
    verticalAlign: 'middle',
    marginTop: -2,
  },
});

const SignUpEmailConfirm = ({ error, loading, onSubmit, autoRedirectCountdown, theme, classes }) => (
  <Paper
    className={classes.root}
    square
    elevation={5}
  >
    <Typography
        className={classes.typography}
        color="secondary"
      >
        Email confirmation
    </Typography>
    {loading > 0 &&
      <Progress />
    }
    {(error && loading === 0) &&
      <FormError className={classes.formError}>
        {error}
      </FormError>
    }
    {(!error && loading === 0) &&
      <Typography variant="subheading" align="center">
        <IconCheck className={classes.iconCheck} /> Email successfully confirmed! <br />
        Just a few more steps and you're done.
      </Typography>
    }
    <div className={classes.footer}>
      <Grid
        className={classes.grid}
        container
        justify="space-between"
        alignItems="center"
        spacing={16}
      >
        <Grid item>
          <Typography variant="caption">
            STEP 2/4
          </Typography>
        </Grid>
        <Grid item>
          <Grid
            container
            justify="space-between"
            alignItems="center"
            spacing={16}
          >
            {(!error && loading === 0) &&
              <Grid item>
                <Typography variant="caption">
                  in <b>{Math.ceil(autoRedirectCountdown/20)}</b> sec
                </Typography>
              </Grid>
            }
            <Grid item>
              <Button
                style={{
                  background: `linear-gradient(
                    to left,
                    ${theme.palette.primary[500]} 0%,
                    ${theme.palette.primary[500]} ${autoRedirectCountdown}%,
                    ${theme.palette.primary[700]} ${autoRedirectCountdown}%,
                    ${theme.palette.primary[700]} 100%)`,
                }}
                onClick={onSubmit}
                variant="raised"
                color="primary"
                disabled={loading > 0 || error}
                size="lg"
              >
                Next
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  </Paper>
);

SignUpEmailConfirm.propTypes = {
  autoRedirectCountdown: PropTypes.number.isRequired,
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      primary: PropTypes.shape({
        500: PropTypes.string.isRequired,
        A100: PropTypes.string.isRequired,
        A400: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};



export default withStyles(styles, { withTheme: true })(SignUpEmailConfirm);



// WEBPACK FOOTER //
// ./src/components/account/SignUpEmailConfirm/SignUpEmailConfirm.js